// Unified aggregator for all tool configurations.
// Collects default exports from each `src/tools/*/index.ts` and
// normalizes them into a single `tools` array for app consumption.

import type { CedarModuleConfig } from './types';

// Re-export shared types for convenience
export type { CedarTool, CedarDomain, CedarModuleConfig } from './types';

interface ModuleExport {
  default?: CedarModuleConfig;
  key?: string;
  domain: CedarModuleConfig['domain'];
  routes?: CedarModuleConfig['routes'];
  tools: CedarModuleConfig['tools'];
}

const modules = import.meta.glob<ModuleExport>('./*/index.{ts,tsx}', { eager: true });

export const cedarModules: CedarModuleConfig[] = Object.entries(modules)
  .map(([p, mod]) => {
    const config = (mod.default || mod) as CedarModuleConfig & ModuleExport;
    const parts = p.split('/');
    const folder = parts[parts.length - 2] || '';
    return {
      key: config.key || folder,
      enabled: config.enabled,
      name: config.domain.title || 'Unknown',
      domain: config.domain,
      routes: config.routes || [],
      tools: config.tools || [],
    };
  })
  .filter((module) => module.enabled !== false && !module.domain.shouldHide)
  .sort((a, b) => a.name.localeCompare(b.name));
